export default __webpack_public_path__ + "static/me-8f1021b05caa582b2ac55620a91b84bb.svg";